// modules
import { get } from 'lodash'

export const convertDataFields = (
  collection = [],
  childrenKey = 'children',
  fields = []
) =>
  Array.isArray(collection)
    ? [...collection].map((node = {}) => {
        const updatedNode = {
          key: node?.uuid || node?.value || null,
          title:
            node?.title ||
            node?.name ||
            node?.number ||
            node?.fullName ||
            node?.refValue ||
            node?.label ||
            node?.content ||
            '',
          label:
            node?.title ||
            node?.name ||
            node?.number ||
            node?.fullName ||
            node?.refValue ||
            node?.label ||
            node?.content ||
            '',
          value: get(node, ['uuid'], get(node, ['value'], null)),
          searchField: node?.searchField || null
        }
        updatedNode.label = updatedNode.title

        if ('disabled' in node) {
          updatedNode.disabled = node.disabled
        }

        fields.forEach((field) => {
          if (field in node) {
            updatedNode[field] = node[field]
          }
        })

        if (childrenKey in node && childrenKey.length) {
          updatedNode[childrenKey] = convertDataFields(
            node[childrenKey],
            childrenKey,
            fields
          )
        }
        return updatedNode
      })
    : collection
